// AUTO-GENERATED by scripts/generate-build-info.js — do not edit.
export const BUILD_INFO = {
  version: "1.0.0",
  gitSha: "7ac79d23",
  buildDate: "2026-11-03"
} as const;
